import { TFunction } from 'i18next';

import { SETTINGS_PROJECT_CONFIG } from '~/modules/settings/projects';
import { ComplianceExperienceId } from '~/services/compliance/experience';

export const getSubscriptionMenuTitle = (
  t: TFunction,
  experienceId: ComplianceExperienceId,
): string => {
  if (
    experienceId === ComplianceExperienceId.V1 ||
    experienceId === ComplianceExperienceId.V2
  ) {
    return t('general:manage_subscription', 'Manage Subscription');
  }

  return SETTINGS_PROJECT_CONFIG.getSubscriptionTitle(t);
};
